// #23662: grouping a detail grid by store (the KPI and SPS default) moves the store name out of the
// "Raison sociale" cell and into the group column. The group header then has to open the store
// detail the same way, or the click only exists once the user ungroups.
//
// The component is handed in by the builder (CompanyName.vue) so this module stays free of .vue imports.

/**
 * Store id shared by every row of a group, or null. Groups are keyed on the store NAME: two stores
 * with the same name land in one group, which must not open either of them. Also used by the mobile
 * cards (TouchCardData) for their store group headers.
 *
 * @param {Array<object>} rows leaf rows of the group
 * @param {string} [field='deliveryLocationId'] row field holding the store id
 * @returns {number|string|null}
 */
export function getSingleDeliveryLocationId(rows, field = 'deliveryLocationId') {
	const ids = new Set((rows || []).map((row) => row?.[field]).filter((id) => id !== null && id !== undefined && id !== ''));
	return ids.size === 1 ? [...ids][0] : null;
}

/**
 * `autoGroupColumnDef` rendering the store grouping level through `component`. Every other level
 * returns no selector result and keeps AG Grid's default inner renderer, count suffix included.
 *
 * @param {string} groupColId colId of the hidden row-group column keyed on the store
 * @param {object} component inner renderer receiving `params.deliveryLocationId`
 * @returns {object}
 */
export function buildDeliveryLocationAutoGroupColumnDef(groupColId, component) {
	return {
		cellRendererParams: {
			innerRendererSelector: (params) => (params.node?.rowGroupColumn?.getColId?.() === groupColId ? { component, params: { deliveryLocationId: getSingleDeliveryLocationId((params.node.allLeafChildren || []).map((leaf) => leaf?.data)) } } : undefined),
		},
	};
}
